import React from "react";

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "500px",
    width: "100%",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  header: {
    marginBottom: "15px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  description: {
    fontSize: "14px",
    color: "#666",
  },
  body: {
    marginBottom: "15px",
  },
  footer: {
    textAlign: "right",
  },
  button: {
    padding: "8px 16px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  noteContent: {
    maxHeight: "300px",
    overflowY: "auto",
    whiteSpace: "pre-wrap",
    border: "1px solid #ddd",
    padding: "10px",
    marginTop: "10px",
  },
};

const NoteModal = ({ isOpen, onClose, note }) => {
  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.header}>
          <h2 style={modalStyles.title}>Note Details</h2>
          <p style={modalStyles.description}>ID: {note.id}</p>
        </div>
        <div style={modalStyles.body}>
          <p>
            <strong>Type:</strong> {note.type}
          </p>
          <p>
            <strong>Created:</strong> {note.created}
          </p>
          <p>
            <strong>Updated:</strong> {note.updated}
          </p>
          <p>
            <strong>Note:</strong>
          </p>
          <div style={modalStyles.noteContent}>{note.note}</div>
        </div>
        <div style={modalStyles.footer}>
          <button style={modalStyles.button} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
